module.exports = __webpack_public_path__ + "static/media/search.effb580d.svg";